function isEdge(userAgent) {
    return userAgent.toLowerCase().includes('edge');
}

function isEdgeOlderThan(version, userAgent) {
    const EDGE = 'edge/';
    const currentVersion = parseInt(userAgent.slice(userAgent.toLowerCase().indexOf(EDGE) + EDGE.length), 10);
    return currentVersion < version;
}

function isFirefox(userAgent) {
    return userAgent.toLowerCase().includes('firefox');
}

function isIE(userAgent) {
    return userAgent.toLowerCase().includes('trident');
}

function isSafari(element) {
    const documentRef = element.ownerDocument;
    const windowRef = documentRef && documentRef.defaultView;
    return !!windowRef && 'safari' in windowRef;
}

/**
 * Generated bundle index. Do not edit.
 */

export { isEdge, isEdgeOlderThan, isFirefox, isIE, isSafari };

//# sourceMappingURL=taiga-ui-cdk-utils-browser.js.map